import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { PaysDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-pays',
  templateUrl: './pays.component.html',
  styleUrls: ['./pays.component.css']
})
export class PaysComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.pays$) pays$: Observable<PaysDto[]>;
  
  @Input('paysId') public paysId: number;

  PaysInComponent: PaysDto;

  p: Subscription;
  
  constructor() {}

  ngOnInit() {
    this.p = this.pays$.subscribe(res => {
      if (res != null) {
        let pays = res.filter(p => p.Id == this.paysId);
        this.PaysInComponent = pays.length == 1 ? pays[0] : { Nom: null };
      }
    });
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }

}
